// Shared file-upload validation constants. Single source of truth — previously duplicated
// locally in src/pages/charts/patient-chart/PatientChart.tsx; also consumed by the drug-screen
// upload flow (QMD-4089).
export const ALLOWED_FILE_EXTENSIONS = ['pdf', 'doc', 'docx', 'jpg', 'jpeg', 'png', 'bmp', 'csv']
export const ALLOWED_FILE_EXTENSIONS_ERROR = ['.pdf', '.doc', '.docx', '.jpg', '.jpeg', '.png', '.bmp', '.csv']
export const ALLOWED_FILE_EXTENSIONS_STR = ALLOWED_FILE_EXTENSIONS_ERROR.join(', ')
export const SIZE_10_MB = 10485760
